export type TrialUserExpiredDataType = {
  label: string;
  value: number;
};
export const TrialUserExpiredData: TrialUserExpiredDataType[] = [
  { label: "2 days", value: 2 },
  { label: "7 days", value: 7 },
  { label: "1 month", value: 1 },
  { label: "3 months", value: 3 },
];
